import { ExperimentConfig } from '@redbubble/next-amplitude';
import { useAmplitudeExperiment } from '@redbubble/next-provider/amplitude';
import { getTopicNavBehaviour } from './types';
export var useTopicNavExperiment = function () {
    return getTopicNavBehaviour(useAmplitudeExperiment(ExperimentConfig.NavTopicsInternal));
};
